import * as React from "react"
const SvgComponent = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={34}
    fill="none"
    {...props}
  >
    <path
      fill="#044E97"
      fillRule="evenodd"
      d="M35.656 11.095a1.25 1.25 0 0 0-.015-1.543L28.6.75H7.397L.356 9.552a1.25 1.25 0 0 0-.014 1.544L17.02 32.763A1.25 1.25 0 0 0 19 32.762l16.655-21.667ZM13 12h10V8.667h-10V12Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent